import { render, staticRenderFns } from "./DrawerTextForm.vue?vue&type=template&id=969e00e4&scoped=true"
import script from "./DrawerTextForm.vue?vue&type=script&lang=js"
export * from "./DrawerTextForm.vue?vue&type=script&lang=js"
import style0 from "./DrawerTextForm.vue?vue&type=style&index=0&id=969e00e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969e00e4",
  null
  
)

export default component.exports